export default __webpack_public_path__ + "static/media/info_cidade.3949fde4.svg";